/**
 * 联系。
 *
 * 收口段落，所以只做一件事：让人真的能找到我。个人微信码放在最上面、放到能扫的
 * 尺寸（≥160px，手机举起来就能扫），微信号和邮箱作为读数摆在旁边——码扫不动时
 * 还有第二条路。下面三个自媒体渠道是「看更新」的入口，不是联系方式，所以版式
 * 明确降一级：小码、灰标题，不和上面那块抢。
 *
 * 上面那块面板是 ContactPanel，/support 用的是同一个组件——两处的联系方式必须
 * 长得一模一样。
 */
import ContactPanel from '@/components/rack/ContactPanel';

/** 自媒体入口 —— 沿用站点原有的三个渠道与二维码素材 */
const channelsOut = [
  {
    name: '视频号',
    handle: '阳仔AI技术支持',
    meta: '1万+ 粉丝',
    desc: '每日分享 AI 工具使用技巧',
    qr: '/social/wechat-video.png',
  },
  {
    name: '抖音',
    handle: '@阳仔AI技术支持',
    meta: '近 10 万粉丝',
    desc: 'All in AI · 十年大厂技术人',
    qr: '/social/douyin.png',
  },
  {
    name: '小红书',
    handle: '阳仔AI技术支持',
    meta: '持续更新',
    desc: '1000 个有爱的 AI 应用 · 深度测评',
    qr: '/social/xiaohongshu.png',
  },
];

export default function ContactSection() {
  return (
    <section
      id="contact"
      className="border-t border-rack-bone/[0.08] bg-rack-ground py-20 sm:py-28"
      aria-labelledby="contact-title"
    >
      <div className="mx-auto max-w-[1180px] px-6 sm:px-10">
        <div className="flex flex-wrap items-baseline gap-x-5 gap-y-2">
          <span className="font-readout text-[11px] tracking-[0.22em] text-rack-amber">CONTACT</span>
          <h2
            id="contact-title"
            className="font-songti text-[clamp(1.5rem,4vw,2.15rem)] font-semibold tracking-[0.14em] text-rack-bone"
          >
            联系
          </h2>
        </div>

        <p className="mt-7 max-w-[34ch] font-songti text-[clamp(1.15rem,2.9vw,1.6rem)] font-semibold leading-[1.5] tracking-[0.08em] text-rack-bone/92">
          有具体的事，直接说
        </p>
        <p className="mt-5 max-w-[60ch] text-[13.5px] leading-[1.95] text-rack-bone/50">
          合作、外包、技术咨询，或者只是想聊聊某个方向怎么落地——扫下面这个码加我，
          说清场景、现状和时间点，我先回你能不能做、值不值得做。判断不收钱。
        </p>

        <div className="mt-10">
          <ContactPanel />
        </div>

        {/* ── 降一级：自媒体，看更新用的，不是联系方式 ── */}
        <div className="mt-14 flex flex-wrap items-baseline gap-x-4 gap-y-1">
          <span className="font-readout text-[10px] uppercase tracking-[0.2em] text-rack-bone/28">
            CHANNELS
          </span>
          <h3 className="text-[13px] text-rack-bone/60">日常更新在这三个地方</h3>
        </div>

        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {channelsOut.map((c) => (
            <div
              key={c.name}
              className="overflow-hidden rounded-[10px] border border-rack-bone/10 bg-rack-panel"
            >
              <div className="flex items-center justify-between gap-3 border-b border-rack-bone/[0.08] bg-rack-chrome px-4 py-2.5">
                <span className="text-[12.5px] font-medium text-rack-bone/85">{c.name}</span>
                <span className="font-readout text-[9.5px] uppercase tracking-[0.14em] text-rack-bone/30">
                  {c.meta}
                </span>
              </div>
              <div className="flex items-center gap-4 p-4">
                <img
                  src={c.qr}
                  alt={`${c.name} 二维码`}
                  loading="lazy"
                  className="h-[86px] w-[86px] shrink-0 rounded-sm border border-rack-bone/10 bg-rack-bone/[0.04] object-contain p-1"
                />
                <div className="min-w-0">
                  <p className="truncate text-[12.5px] text-rack-bone/80">{c.handle}</p>
                  <p className="mt-1.5 text-[11.5px] leading-relaxed text-rack-bone/42">{c.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
